/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { AgentSetupState } from "./data-contracts";

/**
 * @description Get the state of the agent.
 * @tags agents, critical
 * @name GetAgentSetupState
 * @summary Get the agents setup state
 * @request GET:/orgs/{organizationId}/agents-setup
 * @secure
 */

// @ts-ignore
export const getAgentSetupState: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: AgentSetupState;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/agents-setup",
  method: "get",
  streaming: false,
  tags: ["agents", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * @description Delete all the conversations, conversation issues, and issue clusters used by Docs Agent for an organization.
 * @tags agents, critical
 * @name DeleteAgentSetup
 * @summary Delete the agents setup data
 * @request DELETE:/orgs/{organizationId}/agents-setup
 * @secure
 */

// @ts-ignore
export const deleteAgentSetup: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/agents-setup",
  method: "delete",
  streaming: false,
  tags: ["agents", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};
